export default {"src":"/login-app/[GIT_HASH]/_next/static/media/admin.eb9b8abb.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};